module.exports = __webpack_public_path__ + "media/images/temp/ribbon-6-19d665e9e081236adb04191f560cb834.png";